import { createFileRoute } from "@tanstack/react-router";
import { PricingPage } from "@/pages/pricing";
import { head, loader } from "@/pages/pricing.meta";

export const Route = createFileRoute("/$locale/pricing")({
  loader,
  head,
  component: PricingPage,
});
